/**
 * HEIC/HEIF detection.
 *
 * We do NOT support HEIC: in-browser conversion needs WASM (blocked by our
 * CSP) and server-side pure-JS decoding is too slow. HEIC/HEIF uploads are
 * rejected up front with a clear "unsupported format" dialog (see
 * `useImageUpload`), guiding the user to JPG/PNG/WebP.
 *
 * iOS Safari sometimes hands us HEIC with an empty or non-standard MIME type,
 * so we sniff the filename extension too.
 */
export function isHeicFile(file: File): boolean {
  return (
    file.type === "image/heic" ||
    file.type === "image/heif" ||
    /\.(heic|heif)$/i.test(file.name)
  );
}
